module.exports = __webpack_public_path__ + "static/media/111.5562dad4.jpg";